export default {
  message: {
    menu: ["ABOUT", "PRODUCT", "CONTACT", "AVAILABLE", "HOME"],
    section2: {
      title: ["Healthy", "Vegetarian", "For Everyone"],
      text: [
        "Huahed is made from healthy mushrooms, grown from rice bran, manufactured process under GMP certified. Huahed has high contents of fibre, protiens, vitamin B and C. Huahed does not use preservatives and additives. It is the healthier snack for everyone of all ages.",
        "Made from enoki and oyster mushrooms",
        "Selected only the best part of mushrooms to keep its aroma and mouth watering flavor, great taste for everyone in the family."
      ]
    },
    section3: {
      title: [
        "Enoki Mushroom Original Flavor",
        "CRISPY OYSTER MUSHROOM",
        "CRISPY ENOKI MUSHROOM",
        "CRISPY OYSTER MUSHROOM"
      ],
      sub: ["Original", "Original", "Spicy", "Tomyam"],
      button: "Product"
    },
    section4: {
      title: "Available at"
    },
    footer: {
      r1: "Privacy",
      r2:
        "42/3 Phahonyathin 11, Phahonyothin Road, Phayathai, Phayathai Bangkok 10400",
      r3: "Social"
    },
    about: {
      section1: {
        title: "ABOUT",
        text:
          "Mayanakarn Co.,Ltd introduced the new choice for healthy snacks to the market on 19TH August 2015 and become a leader in crispy mushroom chips industry. Our business is manufacturing and distributing mushroom snack products such as crispy enoki mushroom, crispy oyster mushroom. Under Mayanakarn’s own brand named “ HUAHED”. Over 4 years of our commitment to continue our products at high quality, We started the quality control procedure from the beginning. Our snacks are made from carefully picked fresh organic mushroom, Process with our secret receipt, cultivated in closing area, No additives and no preservatives. The way of our business comes from started to the end such as quality control, Innovation and price controlling to meet our customer’s highest satisfaction. And everyone can enjoy it"
      },
      section2: {
        title: "ABOUT US",
        text: [
          "Mayanakarn Co.,Ltd introduced the new choice for healthy snacks to the market on 19TH August 2015 and become a leader in crispy mushroom chips industry. Our business is manufacturing and distributing mushroom snack products such as crispy enoki mushroom, crispy oyster mushroom. Under Mayanakarn’s own brand named “ HUAHED”. Over 4 years of our commitment to continue our products at high quality, We started the quality control procedure from the beginning. Our snacks are made from carefully picked fresh organic mushroom, Process with our secret receipt, cultivated in closing area, No additives and no preservatives. The way of our business comes from started to the end such as quality control, Innovation and price controlling to meet our customer’s highest satisfaction. And everyone can enjoy it"
        ]
      }
    },
    product: {
      title: "PRODUCT",
      button: "FIND IN STORE",
      item: [
        {
          title: "Enoki Mushroom Original Flavor",
          text:
            "Crispy Enoki mushroom original flavor (green pack) made from healthy Enoki mushroom, high protein vitamin B and fiber as well as iron, yummy at all ages, vegetarian welcome, shelf life up to 12 months"
        },
        {
          title: "Oyster Mushroom Tomyum Flavor",
          text:
            "Crispy Oyster Mushroom Tomyum Flavor (orange pack) made from healthy Oyster mushroom, high protein, vitamin C and fiber as well as iron, yummy at all ages, vegetarian welcome, shelf life up to 12 months."
        },
        {
          title: "Oyster Mushroom Original Flavor",
          text:
            "Crispy Oyster Mushroom Orignal flavor (yellow pack) made from healthy Oyster mushroom, high protein, vitamin C and fiber as well as iron, yummy at all ages, vegetarian welcome, shelf life up to 12 months."
        },
        {
          title: "Enoki Mushroom Spicy Flavor",
          text:
            "Crispy Enoki mushroom spicy flavour (red pack) made from healthy Enoki mushroom high, protein vitamin B, high fiber as well as iron, yummy at all age, vegetarian welcome, shelf life up to 12 months."
        }
      ]
    },
    contact: {
      title: ["CONTACT", "LEAVE A MESSAGE"],
      address: [
        {
          title: "ADDRESS",
          text:
            "42/3 Phahonyathin 11, Phahonyothin Road, Phayathai,Phayathai, Bangkok 10400"
        },
        {
          title: "EMAIL",
          text: "sales@mayanakarn.com"
        },
        {
          title: "PHONE",
          text: "0922749396"
        }
      ],
      form: [
        "Your name",
        "Subject",
        "Your email",
        "Your phone",
        "Your message"
      ],
      button: "SEND"
    },
    available: {
      title: "FIND IN STORE",
      text:
        "Our snacks are available at Tops Super Market, Central Food Hall, Gourmet Market, Home Fresh mart, Siam Paragon 7Eleven, Tesco, Big C and more than 400 grocery stores nationwide."
    },
    privacy: {
      title: "PRIVACY & TERMS",
      content: [
        {
          title: "Privacy Policy of huahed",
          child: [
            `huahed operates the http://mayanakarn.com/ website, which provides the SERVICE.
            This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service, the huahed website.`,
            `If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.`,
            `The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at huahed.vasin.me, unless otherwise defined in this Privacy Policy. Our Privacy Policy was created with the help of the Privacy Policy Template.`
          ]
        },
        {
          title: "Information Collection and Use",
          child: [
            `For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.`
          ]
        },
        {
          title: "Log Data",
          child: [
            `We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol ("IP") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.`
          ]
        },
        {
          title: "Cookies",
          child: [
            `Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.`,
            `Our website uses these "cookies" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.`
          ]
        },
        {
          title: "Service Providers",
          child: [
            `We may employ third-party companies and individuals due to the following reasons`,
            ` - To facilitate our Service;`,
            ` - To provide the Service on our behalf;`,
            ` - To perform Service-related services; or`,
            ` - To assist us in analyzing how our Service is used.`,
            `We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.`
          ]
        },
        {
          title: "Security",
          child: [
            `We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.`
          ]
        },
        {
          title: "Links to Other Sites",
          child: [
            `Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.`
          ]
        },
        {
          title: "Children’s Privacy",
          child: [
            `Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.`
          ]
        },
        {
          title: "Changes to This Privacy Policy",
          child: [
            `We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.`
          ]
        },
        {
          title: "Contact Us",
          child: [
            `If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.`
          ]
        }
      ]
    }
  }
};
